import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { DTORBIT_URL } from "@/constants";
import { timeAgo } from "@/hooks/useRate";

export default function RateTicker({ rate }) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 480);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const formatted =
        rate.rate !== null && rate.rate !== undefined
            ? `₹${Number(rate.rate).toFixed(2)}`
            : null;

    return (
        <div
            data-testid="rate-ticker"
            aria-hidden={!visible}
            className={`fixed inset-x-0 top-16 md:top-[72px] z-40 transition-all duration-300 ${
                visible
                    ? "translate-y-0 opacity-100"
                    : "-translate-y-full opacity-0 pointer-events-none"
            }`}
        >
            <div className="glass border-b border-[#E4EAF6]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 h-11 flex items-center justify-between gap-3">
                    <div className="flex items-center gap-2.5 min-w-0">
                        {rate.live && <span className="live-dot" />}
                        <span
                            data-testid="rate-ticker-value"
                            className="text-xs sm:text-sm font-extrabold font-display text-[#0F1B3D] whitespace-nowrap"
                        >
                            {formatted ? (
                                <>
                                    1 USDT = <span className="text-[#1E56FF]">{formatted}</span>
                                </>
                            ) : (
                                "Fetching live rate…"
                            )}
                        </span>
                        {rate.updatedAt && (
                            <span className="text-[11px] text-[#8494B0] hidden sm:inline whitespace-nowrap">
                                · Updated {timeAgo(rate.updatedAt)}
                            </span>
                        )}
                    </div>
                    <a
                        href={DTORBIT_URL}
                        data-testid="rate-ticker-start-exchange-button"
                        tabIndex={visible ? 0 : -1}
                        className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-bold text-[#1E56FF] hover:text-[#0A1F9E] transition-colors whitespace-nowrap group"
                    >
                        Start Exchange
                        <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5" />
                    </a>
                </div>
            </div>
        </div>
    );
}
